// Casino game type from the admin URL.
//
//   /admin/casino/<type>   → Live Market         → <type> as-is (teen20, lucky7, ...)
//   /admin/vcasino/<slug>  → Live Virtual Market → virtual feed (vteen20, vlucky7, ...)
//
// Virtual games ka apna feed hai (user site "Our Virtual" tab ke slugs:
// frontend/src/constants/casinoCategories.js provider "19"). Pehle har page
// `/\/casino\//` regex use karta tha, jo /vcasino/ par null deta tha — isliye
// Live Virtual Market ke games load hi nahi hote the.
export const VIRTUAL_CASINO_TYPES = {
  dtl20: 'vdtl20',
  aaa2: 'vaaa',
  aaa: 'vaaa',
  teenmuf: 'vteenmuf',
  teen: 'vteen',
  dt6: 'vdt6',
  lucky7: 'vlucky7',
  btable: 'vbtable',
  teen20: 'vteen20',
  trio: 'vtrio',
}

export function extractCasinoGame(pathname = '') {
  const match = String(pathname).match(/\/(v?casino)\/([^/?#]+)/)
  if (!match) return null
  const slug = match[2]
  if (match[1] === 'vcasino') return VIRTUAL_CASINO_TYPES[slug.toLowerCase()] || slug
  return slug
}

export const isVirtualCasinoType = (type) =>
  Object.values(VIRTUAL_CASINO_TYPES).includes(String(type || '').toLowerCase())

// vteen20 → teen20: result UI / bet table choose karne ke liye (feed shape same hai)
export function baseCasinoType(type) {
  const t = String(type || '').toLowerCase().trim()
  if (!isVirtualCasinoType(t)) return t
  const base = Object.keys(VIRTUAL_CASINO_TYPES).find((k) => VIRTUAL_CASINO_TYPES[k] === t && k !== 'aaa')
  return base || t
}

// Page heading per API type (user site ke game names). Jo type yahan nahi hai
// uske liye page apna purana fallback title dikhata hai.
const CASINO_TITLES = {
  vdtl20: 'Virtual 20-20 D T L',
  vaaa: 'Virtual Amar Akbar Anthony',
  vteenmuf: 'Virtual Muflis Teenpatti',
  vteen: 'Virtual Teenpatti 1-day',
  vdt6: 'Virtual Dragon Tiger 1-Day',
  vlucky7: 'Virtual Lucky 7',
  vbtable: 'Virtual Bollywood Casino',
  vteen20: 'Virtual 20-20 Teenpatti',
  vtrio: 'Virtual Trio',
  teen: 'Teenpatti 1-day',
  pteen: 'Premium Teenpatti 1-day',
  teen20: '20-20 Teenpatti',
  pteen20: 'Premium 20-20 Teenpatti',
  dt6: '1 Day Dragon Tiger',
  lucky7: 'Lucky 7 - A',
  plucky7: 'Premium Lucky 7',
  trio: 'Trio',
  btable: 'Bollywood Casino',
  btable2: 'Bollywood Casino 2',
  aaa: 'Amar Akbar Anthony',
  aaa2: 'Amar Akbar Anthony 2.0',
  cmatch20: 'Cricket Match 20-20',
  cmeter: 'Casino Meter',
  cmeter1: '1 Card Meter',
}

export const casinoTitle = (type, fallback = '') =>
  CASINO_TITLES[String(type || '').toLowerCase()] || fallback
